module.exports = __webpack_public_path__ + "static/img/8.34b1e64.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/8.jpg
// module id = NR3L
// module chunks = 1